import { motion } from "framer-motion";
import { MessageCircle, CalendarDays, Video } from "lucide-react";
import { fadeInUp, staggerContainer } from "@/components/motionVariants";

const steps = [
  {
    id: "add-line",
    title: "เพิ่ม LINE",
    description: "แอด LINE เพื่อเริ่มบทสนทนาส่วนตัวที่ปลอดภัย",
    icon: MessageCircle,
  },
  {
    id: "pick-time",
    title: "เลือกเวลาที่สะดวก",
    description: "เลือกช่วงเวลาที่คุณสบายใจและเป็นส่วนตัวที่สุด",
    icon: CalendarDays,
  },
  {
    id: "private-session",
    title: "ปรึกษาแบบส่วนตัว 1-ต่อ-1",
    description: "พูดคุยอย่างเป็นส่วนตัวผ่าน LINE ในพื้นที่ปลอดภัยที่มีแค่คุณกับทรายเท่านั้น",
    icon: MessageCircle,
  },
];

export const HowItWorks = () => {
  return (
    <motion.section
      id="how-it-works"
      className="py-16 md:py-24"
      data-testid="how-it-works-section"
      {...fadeInUp}
    >
      <div className="mx-auto max-w-md px-6 md:max-w-4xl md:px-12 lg:max-w-6xl">
        <motion.h2
          {...fadeInUp}
          className="font-serif text-3xl text-taupe md:text-4xl"
          data-testid="how-it-works-title"
        >
          วิธีการดูแลหัวใจของคุณอย่างง่าย
        </motion.h2>
        <motion.p
          {...fadeInUp}
          className="mt-4 text-base text-taupeLight"
          data-testid="how-it-works-subtitle"
        >
          แค่ 3 ขั้นตอนสั้น ๆ เพื่อเริ่มต้นการปรึกษาแบบส่วนตัวที่อ่อนโยนที่สุด
        </motion.p>
        <motion.div
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          className="mt-10 grid gap-6 md:grid-cols-3"
          data-testid="how-it-works-grid"
        >
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <motion.div
                key={step.id}
                variants={fadeInUp}
                className="flex h-full flex-col gap-4 rounded-2xl border border-gold/20 bg-white px-6 py-8 shadow-soft"
                data-testid={`how-it-works-card-${step.id}`}
              >
                <div className="flex items-center gap-3">
                  <div
                    className="flex h-12 w-12 items-center justify-center rounded-full bg-gold/15"
                    data-testid={`how-it-works-icon-${step.id}`}
                  >
                    <Icon className="h-6 w-6 text-taupe" />
                  </div>
                  <span className="text-sm text-taupeLight" data-testid={`how-it-works-step-${step.id}`}>
                    Step {index + 1}
                  </span>
                </div>
                <h3 className="text-xl font-semibold text-taupe" data-testid={`how-it-works-title-${step.id}`}>
                  {step.title}
                </h3>
                <p className="text-sm text-taupeLight" data-testid={`how-it-works-description-${step.id}`}>
                  {step.description}
                </p>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </motion.section>
  );
};